export default
{
	availableUnits: 10,
	score: {
		min: 4,
		max: 8,
        displayMax: 11
	},
	name: "delier6",
	day: 3,
	date: {
		time: "09:33",
		day: "scene.date.text"
	},
	patientState: 0,
	delirium: {
		initialState: "oranje",
		clockPosition: {
			x: 778,
			y: 188
		},
		videoUrls: [
			{
				whiteboardState: 0,
				blindsState: 0,
				url: "delier6/${locale}/delier_6_nacht_ochtend_blinds-dicht.flv"
			},
			{
				whiteboardState: 1,
				blindsState: 0,
				url: "delier6/${locale}/delier_6_nacht_ochtend_blinds-dicht_ma.flv"
			},
			{
				whiteboardState: 2,
				blindsState: 0,
				url: "delier6/${locale}/delier_6_nacht_ochtend_blinds-dicht_di.flv"
			},
			{
				whiteboardState: 3,
				blindsState: 0,
				url: "delier6/${locale}/delier_6_nacht_ochtend_blinds-dicht_wo.flv"
			}
			
		],
		roomViewToggleButtonPosition: {
			x: 1204,
			y: 283
		}
	},
	room: {
		backgroundImage: {
			blindsOpenUrl: "delier6/delier6_nurseview_room_blinds_open.jpg",
			blindsClosedUrl: "delier6/delier6_nurseview_room_blinds_closed.jpg"
		},
		clock: {
			blindsOpenUrl: "delier6/delier6_nurseview_room_blinds_open_klok.png",
			blindsClosedUrl: "delier6/delier6_nurseview_room_blinds_closed_klok.png"
		}
	},
	end: {
		clockPosition: {
			x: 784,
			y: 184
		},
		videoUrls: [
			{
				whiteboardState: 0,
				blindsState: 0,
				url: "delier6/${locale}/delier_6_slot_blinds_dicht.flv"
			},
			{
				whiteboardState: 1,
				blindsState: 0,
				url: "delier6/${locale}/delier_6_slot_blinds_dicht_ma.flv"
			},
			{
				whiteboardState: 2,
				blindsState: 0,
				url: "delier6/${locale}/delier_6_slot_blinds_dicht_di.flv"
			},
			{
				whiteboardState: 3,
				blindsState: 0,
				url: "delier6/${locale}/delier_6_slot_blinds_dicht_wo.flv"
			},
			{
				whiteboardState: 4,
				blindsState: 0,
				url: "delier6/${locale}/delier_6_slot_blinds_dicht_do.flv"
			},
			{
				whiteboardState: 0,
				blindsState: 1,
				url: "delier6/${locale}/delier_6_slot_blinds_open.flv"
			},
			{
				whiteboardState: 1,
				blindsState: 1,
				url: "delier6/${locale}/delier_6_slot_blinds_open_ma.flv"
			},
			{
				whiteboardState: 2,
				blindsState: 1,
				url: "delier6/${locale}/delier_6_slot_blinds_open_di.flv"
			},
			{
				whiteboardState: 3,
				blindsState: 1,
				url: "delier6/${locale}/delier_6_slot_blinds_open_wo.flv"
			},
			{
				whiteboardState: 4,
				blindsState: 1,
				url: "delier6/${locale}/delier_6_slot_blinds_open_do.flv"
			}
		]
	},
	transitions: [
		{
			deliriumState: "groen",
			target: "evaluation"
		},
		{
			deliriumState: "oranje",
			target: "evaluation"
		},
		{
			deliriumState: "rood",
			target: "evaluation"
		}
	],
	mediaUrls: [
		{
			categoryName: "communiceren",
			value: "delier6/${locale}/delier_6_dialoog_startloop.flv"
		},
		{
			categoryName: "communiceren",
			actionName: "patientlatenslapen",
			value: "delier6/${locale}/delier_6_dialoog_latenslapen.flv"
		},
		{
			categoryName: "communiceren",
			actionName: "patientvragennaardromen",
			value: "delier6/${locale}/delier_6_dialoog_doorvrhallucinatie.flv"
		},
		{
			categoryName: "communiceren",
			actionName: "orientatievragenstellen",
			value: "delier6/${locale}/delier_6_dialoog_doorvrorientatie.flv"
		},
		{
			categoryName: "communiceren",
			actionName: "afrondenenkamerverlaten",
			value: "delier6/${locale}/delier_6_dialoog_dag.flv"
		}
	]
}